import React from "react";
import './Info.scss';
import successIcon from "../assets/icons/sad_see_you_go_icon.png"
import Footer2 from "./Footer2";
import { reactLocalStorage } from "reactjs-localstorage";
import logo from "../assets/icons/logo.png"

const Sorry =(props)=>{

    const lang = localStorage.getItem("lang")
    const homeLogo = reactLocalStorage.get("home_logo");

    const goToLanding=()=>{
       window.location.replace('/subs')      
    }
 
    return (
        <div className="containerinfo">
            <img src={homeLogo ? homeLogo : logo}
            className="logoinfo"
            alt="logo">
            </img>
            <div className="icon-container">
                <img className="tick" src={successIcon} alt="Success" />
            </div>
            <h1 className="heading">{lang === "en" ? "Sad to see you go" : "حزين لرؤيتك ذاهب"}</h1>
            <p className="para">{lang === "en" ?"Remember cubegames is here whenever you need it" : "تذكر أن cubegames موجودة عندما تحتاج إليها"}</p>
            <button className="btninfo" onClick={goToLanding}>{lang === "en" ? "Go to home" : "اذهب إلى المنزل"}</button>
            <div className="foot">
            <Footer2/>
        </div>
        </div>
    );
}

export default Sorry